import React from "react";
import { Clock, Search, CheckCircle2, XCircle, AlertTriangle } from "lucide-react";

// Maps Blexbot status strings to a visual style + label + icon.
// Colour is never the only cue (icon + text always accompany the badge).
const STATUS_MAP = {
  pending: {
    label: "Pending",
    icon: Clock,
    className: "bg-slate-100 text-slate-800 border-slate-300",
  },
  researching: {
    label: "Researching",
    icon: Search,
    className: "bg-blue-100 text-blue-800 border-blue-300",
  },
  quoted: {
    label: "Quoted",
    icon: CheckCircle2,
    className: "bg-green-100 text-green-800 border-green-300",
  },
  closed: {
    label: "Closed",
    icon: XCircle,
    className: "bg-gray-200 text-gray-800 border-gray-400",
  },
  requires_attention: {
    label: "Requires attention",
    icon: AlertTriangle,
    className: "bg-amber-100 text-amber-900 border-amber-400",
  },
};

const StatusBadge = ({ status }) => {
  const key = (status || "pending").toString().toLowerCase().replace(/\s+/g, "_");
  const meta = STATUS_MAP[key] || STATUS_MAP.pending;
  const Icon = meta.icon;
  return (
    <span
      data-testid={`status-badge-${key}`}
      role="status"
      aria-label={`Request status: ${meta.label}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${meta.className}`}
    >
      <Icon className="w-3.5 h-3.5" aria-hidden="true" />
      {meta.label}
    </span>
  );
};

export default StatusBadge;
